import { Skeleton } from '../shadcn'

export const ItemLayoutSkeleton = () => {
  return (
    <div className="flex items-center gap-2">
      <Skeleton className="rounded-full w-[52px] h-[52px]" />
      <div className="flex flex-col gap-2">
        <Skeleton className="h-5 w-[250px] rounded-2xl" />
        <Skeleton className="h-6 w-[100px] rounded-2xl" />
      </div>
    </div>
  )
}
